export const resource = {
  Login: '登录',
  Logout: '退出',
  LoginLoading: '登录中...',
  'It is detected that you have an unfinished live broadcast session last time. Do you want to resume it?': '检测到您上次直播未结束，是否恢复直播？',
  Warning: '警告',
  'Unable to view own live': '无法观看自己的直播',
  'Failed to join live broadcast session': '加入直播失败',
  // LoginUserID组件相关词条
  'Please configure SDKAPPID': '请在 basic-info-config.js 文件中配置 SDKAPPID',
  'Please enter userID': '请输入userID',
  'Confirm Login': '确认登录',
  'Switch Account': '切换其他账号',
  'Please enter a valid userID': '请输入正确的userID',
  'Please provide a function to generate userSig': '请传入生成 userSig 的函数',
  'Start live': '开始直播',
  'Copy successful': '复制成功',
  'Copy failed': '复制失败',
  'Login failed': '登录失败',
  'Network timeout': '网络请求超时，请检查网络连接。',
  'Unknown error.': '未知错误。',
  'Your current package does not support live streaming.': '您当前的套餐包不支持开播，可能是套餐包过期、未开通等原因。首次使用，可以<a target="_blank" href="https://cloud.tencent.com/document/product/647/105439">开通体验版</a>；也可以前往<a target="_blank" href="https://buy.cloud.tencent.com/trtc">腾讯云控制台</a>购买或者升级套餐包。',
  'The room name cannot exceed 100 bytes. Each Chinese character occupies 2 bytes.': '直播间名称不能超过100个字节，一个汉字占2字节。',
  'The room ID cannot exceed 48 characters.': '直播间 ID 不能超过 48 个字符。',
  'The room ID can only contain letters, numbers, and underscores.': '直播间 ID 只能包含字母、数字、下划线。',
  'The user signature has expired. It is recommended to set the signature validity period to at least 24 hours.': '用户签名已过期，建议生成的签名有效期不少于 24 小时。可参阅 <a target="_blank" href="https://cloud.tencent.com/document/product/269/32688">生成 UserSig(用户鉴权)</a>。',
  'Invalid signature. Please regenerate it.': '非法的用户签名，请重新生成。可参阅 <a target="_blank" href="https://cloud.tencent.com/document/product/269/32688">生成 UserSig(用户鉴权)</a>。',
  'The user ID does not match the user signature. Please check.': '用户 ID 与用户签名不匹配，请检查。可前往腾讯云控制台验证：<a target="_target" href="https://console.cloud.tencent.com/trtc/usersigtool">验证签名</a>。',
  'No active package found or account is in arrears. Please proceed to the Tencent Cloud console to make a purchase.': '未购买套餐包或者已欠费，请前往<a target="_blank" href="https://buy.cloud.tencent.com/trtc">腾讯云控制台购买</a>。首次使用，可以<a target="_blank" href="https://cloud.tencent.com/document/product/647/105439">开通体验版</a>。',
  'This room already exists, and you are the owner.': '该直播间已存在，且您为房主。',
  'The number of members in this room has reached the limit': '当前房间人数已达到套餐上限，请前往<a target="_blank" href="https://buy.cloud.tencent.com/trtc">腾讯云控制台</a>购买或者升级套餐包。',
  'The number of rooms has reached the limit of the payment': '当前房间数量已达到套餐上限，请前往<a target="_blank" href="https://buy.cloud.tencent.com/trtc">腾讯云控制台</a>购买或者升级套餐包。',
  'Room is not existed.': '房间不存在，请检查房间ID。',
  'Not allowed to refresh in picture-in-picture mode': '画中画模式下不允许刷新操作',
};
